import { render, staticRenderFns } from "./ArtikelEdit.vue?vue&type=template&id=0e19c2ed"
import script from "./ArtikelEdit.vue?vue&type=script&lang=js"
export * from "./ArtikelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports